<template>
  <div>
    <Breadcrumbs
      title="Trust (Loan) Process Report"
      :breadcrumbs="[
        { label: 'Reports', path: '' },
        { label: 'Trust (Loan) Process Report', path: '/trust_process_report' },
      ]"
    />

    <div class="container-fluid">
      <div class="row project-cards">
        <TrustProcessReportData />
      </div>
    </div>
  </div>
</template>

<script>
import TrustProcessReportData from "./trust_process_report_data.vue";

export default {
  name: "TrustProcessReport",
  components: {
    TrustProcessReportData,
  },
};
</script>